{
  "version": 1,
  "asset_id": "83e5e70b-dc8f-40fc-a457-f74a0f204f82",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/83e5e70b-dc8f-40fc-a457-f74a0f204f82/arwen-console-detail.png",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/83e5e70b-dc8f-40fc-a457-f74a0f204f82/arwen-console-detail.png",
  "original_filename": "arwen-console-detail.png",
  "size": 1384717,
  "content_type": "image/png",
  "created_at": "2026-07-05T03:27:39Z"
}
